import getRulesFromFilter from './getRulesFromFilter';

const isGrandfatherFilter = (filter, customerCustomTags) => {
  // no custom tags are defined, so no grandfather filters
  if (customerCustomTags === null) {
    return false;
  }

  // just need rules, does not need to know AND or OR between rules
  const filterRules = getRulesFromFilter(filter.rule);
  const customTagsRulesData = Object.values(filterRules).filter((data) => data.field === 'TAG');
  const customTags = customTagsRulesData.map((data) => data.key);
  // if there is a common tag between customTagsInRules and customTags,
  // it is not a grandfather filter
  return customTags.some((tag) => !customerCustomTags.includes(tag));
};

export default isGrandfatherFilter;
